import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutecrumpsService } from '../services/routecrumps.service';
import { MatDialog } from '@angular/material/dialog';
import { NewPwdComponent } from '../user-login/new-pwd/new-pwd.component';
import { KeyValue } from '@angular/common';
import { filter } from 'rxjs/operators';
import { SharedService } from '../services/shared.service';
import CssFilterConverter from 'css-filter-converter';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private router: Router,
    private rcrumpService: RoutecrumpsService,
    // private userloginService: UserLoginService,
    private sharedService: SharedService,
    private matdialog: MatDialog
  ) { }

  label = this.rcrumpService.label;
  applist = this.rcrumpService.applist;
//   applist={
//     "search": [
//         {
//             "url": "explorelogs",
//             "label": "Alerts",
//             "content": "Quickly find logs, events, and incidents across the system",
//             "img_url": "assets/menuicons/explore.svg",
//             "catagory": "search",
//             "menu_name": "explorelogs",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 1,
//             "isSelectable": true,
//             "catagory_order": 1,
//             "is_nonselected_menu_visible": true
//         },
//         {
//           "url": "log-search",
//           "label": "Log Search",
//           "content": "Quickly find logs, events, and incidents across the system",
//           "img_url": "assets/menuicons/explore.svg",
//           "catagory": "search",
//           "menu_name": "explorelogs",
//           "menucolor": {
//               "color": "#858484",
//               "boxShadow": {
//                   "box-shadow": ""
//               },
//               "filterColor": {
//                   "filter": ""
//               }
//           },
//           "menu_order": 5,
//           "isSelectable": true,
//           "catagory_order": 1,
//           "is_nonselected_menu_visible": true
//       },
//         {
//             "url": "rule",
//             "label": "Rule",
//             "content": "Define and manage security policies to automate threat detection",
//             "img_url": "assets/menuicons/rule.svg",
//             "catagory": "search",
//             "menu_name": "rule",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 2,
//             "isSelectable": true,
//             "catagory_order": 1,
//             "is_nonselected_menu_visible": true
//         },
//         {
//           "url": "intel-list",
//           "label": "Intel List",
//           "content": "Define and manage security policies to automate threat detection",
//           "img_url": "assets/menuicons/rule.svg",
//           "catagory": "search",
//           "menu_name": "rule",
//           "menucolor": {
//               "color": "#858484",
//               "boxShadow": {
//                   "box-shadow": ""
//               },
//               "filterColor": {
//                   "filter": ""
//               }
//           },
//           "menu_order": 4,
//           "isSelectable": true,
//           "catagory_order": 1,
//           "is_nonselected_menu_visible": true
//       },
//         {
//             "url": "dashboard",
//             "label": "Dashboard",
//             "content": "Real-time insights into security events and system health",
//             "img_url": "assets/menuicons/bar-chart.svg",
//             "catagory": "search",
//             "menu_name": "dashboard",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 3,
//             "isSelectable": true,
//             "catagory_order": 1,
//             "is_nonselected_menu_visible": true
//         },
//         {
//             "url": "ticketing",
//             "label": "Alerts and ticketing",
//             "content": "High-level view of all security events and system health with real-time SIEM insights",
//             "img_url": "assets/menuicons/alert-ticket.svg",
//             "catagory": "search",
//             "menu_name": "alerts_and_ticketing",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 4,
//             "isSelectable": true,
//             "catagory_order": 1,
//             "is_nonselected_menu_visible": true
//         },
//         {
//             "url": "",
//             "label": "Reports",
//             "content": "Analyze outliers reported by machine learning models",
//             "img_url": "assets/menuicons/report.svg",
//             "catagory": "search",
//             "menu_name": "reports",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 5,
//             "isSelectable": false,
//             "catagory_order": 1,
//             "is_nonselected_menu_visible": true
//         }
//     ],
//     "manage": [
//         {
//             "url": "user",
//             "label": "User",
//             "content": "Manage user accounts and access privileges",
//             "img_url": "assets/menuicons/user.svg",
//             "catagory": "manage",
//             "menu_name": "user",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 1,
//             "isSelectable": true,
//             "catagory_order": 2,
//             "is_nonselected_menu_visible": true
//         },
//         {
//             "url": "role",
//             "label": "Role",
//             "content": "Define and assign roles to control system access",
//             "img_url": "assets/menuicons/role.svg",
//             "catagory": "manage",
//             "menu_name": "role",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 2,
//             "isSelectable": true,
//             "catagory_order": 2,
//             "is_nonselected_menu_visible": true
//         },
//         {
//             "url": "organization",
//             "label": "Organization",
//             "content": "Efficiently handle managed service providers and customers",
//             "img_url": "assets/menuicons/organization.svg",
//             "catagory": "manage",
//             "menu_name": "organization",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 3,
//             "isSelectable": true,
//             "catagory_order": 2,
//             "is_nonselected_menu_visible": true
//         },
//         {
//             "url": "designer",
//             "label": "Studio",
//             "content": "Create and customize interactive dashboards for security insights",
//             "img_url": "assets/menuicons/studio.svg",
//             "catagory": "manage",
//             "menu_name": "studio",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 4,
//             "isSelectable": true,
//             "catagory_order": 2,
//             "is_nonselected_menu_visible": true
//         }
//     ],
//     "operate": [
//         {
//             "url": "pipelinestats",
//             "label": "Pipeline Stats",
//             "content": "Visualizing pipeline metrics across daily and hourly timeframes to highlight anomalies and trends",
//             "img_url": "assets/menuicons/alert-ticket.svg",
//             "catagory": "operate",
//             "menu_name": "pipeline_stats",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 1,
//             "isSelectable": true,
//             "catagory_order": 3,
//             "is_nonselected_menu_visible": true
//         },
//         {
//             "url": "",
//             "label": "Fleet Management",
//             "content": "Understand and manage the health of the log sources",
//             "img_url": "assets/menuicons/fleet.svg",
//             "catagory": "operate",
//             "menu_name": "fleetmanagement",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 1,
//             "isSelectable": false,
//             "catagory_order": 3,
//             "is_nonselected_menu_visible": true
//         },
//         {
//             "url": "collective-dashboard",
//             "label": "Monitoring",
//             "content": "Tracking and analyzing user actions for suspicious behavior",
//             "img_url": "assets/menuicons/monitor.svg",
//             "catagory": "operate",
//             "menu_name": "monitoring",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 2,
//             "isSelectable": true,
//             "catagory_order": 3,
//             "is_nonselected_menu_visible": true
//         },
//         {
//             "url": "",
//             "label": "Deploy",
//             "content": "Install and configure agents to monitor and collect data from endpoints",
//             "img_url": "assets/menuicons/deploy.svg",
//             "catagory": "operate",
//             "menu_name": "deploy",
//             "menucolor": {
//                 "color": "#858484",
//                 "boxShadow": {
//                     "box-shadow": ""
//                 },
//                 "filterColor": {
//                     "filter": ""
//                 }
//             },
//             "menu_order": 3,
//             "isSelectable": false,
//             "catagory_order": 3,
//             "is_nonselected_menu_visible": true
//         }
//     ]
// }
  // applist={
  //   "search": [
  //     {
  //       "url": "alerts",
  //       "label": "Alerts",
  //       "content": "Quickly find logs, events, and incidents across the system",
  //       "img_url": "assets/menuicons/explore.svg",
  //       "catagory": "search",
  //       "menu_name": "explorelogs",
  //       "menucolor": {
  //         "color": "#858484",
  //         "boxShadow": {
  //           "box-shadow": ""
  //         },
  //         "filterColor": {
  //           "filter": ""
  //         }
  //       },
  //       "menu_order": 1,
  //       "isSelectable": true,
  //       "catagory_order": 1,
  //       "is_nonselected_menu_visible": true
  //     },
  //     {
  //       "url": "log-search",
  //       "label": "Log Search",
  //       "content": "Quickly find logs, events, and incidents across the system",
  //       "img_url": "assets/menuicons/explore.svg",
  //       "catagory": "search",
  //       "menu_name": "explorelogs",
  //       "menucolor": {
  //         "color": "#858484",
  //         "boxShadow": {
  //           "box-shadow": ""
  //         },
  //         "filterColor": {
  //           "filter": ""
  //         }
  //       },
  //       "menu_order": 5,
  //       "isSelectable": true,
  //       "catagory_order": 1,
  //       "is_nonselected_menu_visible": true
  //     },
  //     {
  //       "url": "dashboard",
  //       "label": "Dashboard",
  //       "content": "Real-time insights into security events and system health",
  //       "img_url": "assets/menuicons/bar-chart.svg",
  //       "catagory": "search",
  //       "menu_name": "dashboard",
  //       "menucolor": {
  //         "color": "#858484",
  //         "boxShadow": {
  //           "box-shadow": ""
  //         },
  //         "filterColor": {
  //           "filter": ""
  //         }
  //       },
  //       "menu_order": 3,
  //       "isSelectable": true,
  //       "catagory_order": 1,
  //       "is_nonselected_menu_visible": true
  //     }
  //   ],
   
  //   "operate": [
  //     {
  //       "url": "rule",
  //       "label": "Rule",
  //       "content": "Define and manage security policies to automate threat detection",
  //       "img_url": "assets/menuicons/rule.svg",
  //       "catagory": "search",
  //       "menu_name": "rule",
  //       "menucolor": {
  //         "color": "#858484",
  //         "boxShadow": {
  //           "box-shadow": ""
  //         },
  //         "filterColor": {
  //           "filter": ""
  //         }
  //       },
  //       "menu_order": 2,
  //       "isSelectable": true,
  //       "catagory_order": 1,
  //       "is_nonselected_menu_visible": true
  //     },
  //     {
  //       "url": "intel-list",
  //       "label": "Intel List",
  //       "content": "Define and manage security policies to automate threat detection",
  //       "img_url": "assets/menuicons/rule.svg",
  //       "catagory": "search",
  //       "menu_name": "rule",
  //       "menucolor": {
  //         "color": "#858484",
  //         "boxShadow": {
  //           "box-shadow": ""
  //         },
  //         "filterColor": {
  //           "filter": ""
  //         }
  //       },
  //       "menu_order": 4,
  //       "isSelectable": true,
  //       "catagory_order": 1,
  //       "is_nonselected_menu_visible": true
  //     }
  //   ],
  //   "manage": [
  //       {
  //         "url": "user",
  //         "label": "User",
  //         "content": "Manage user accounts and access privileges",
  //         "img_url": "assets/menuicons/user.svg",
  //         "catagory": "manage",
  //         "menu_name": "user",
  //         "menucolor": {
  //           "color": "#858484",
  //           "boxShadow": {
  //             "box-shadow": ""
  //           },
  //           "filterColor": {
  //             "filter": ""
  //           }
  //         },
  //         "menu_order": 1,
  //         "isSelectable": true,
  //         "catagory_order": 2,
  //         "is_nonselected_menu_visible": true
  //       },
  //       {
  //         "url": "role",
  //         "label": "Role",
  //         "content": "Define and assign roles to control system access",
  //         "img_url": "assets/menuicons/role.svg",
  //         "catagory": "manage",
  //         "menu_name": "role",
  //         "menucolor": {
  //           "color": "#858484",
  //           "boxShadow": {
  //             "box-shadow": ""
  //           },
  //           "filterColor": {
  //             "filter": ""
  //           }
  //         },
  //         "menu_order": 2,
  //         "isSelectable": true,
  //         "catagory_order": 2,
  //         "is_nonselected_menu_visible": true
  //       }
  //     ]
  // }

  categoryColums =this.rcrumpService.categoryColums;
  columnsCount  

  categoryIcon ={
    "search":{"img":"assets/menuicons/explore.svg","filter":{"filter": "brightness(0) saturate(100%) invert(61%) sepia(12%) saturate(7309%) hue-rotate(164deg) brightness(94%) contrast(98%)"}},
    "manage":{"img":"assets/menuicons/manage.svg","filter":{"filter": "brightness(0) saturate(100%) invert(55%) sepia(66%) saturate(450%) hue-rotate(68deg) brightness(96%) contrast(90%)"}},
    "operate":{"img":"assets/menuicons/dashboard.svg","filter":{"filter": "brightness(0) saturate(100%) invert(55%) sepia(91%) saturate(408%) hue-rotate(340deg) brightness(102%) contrast(104%)"}},
    "dashboardview":{"img":"assets/menuicons/dashboardview.svg","filter":{"filter": "brightness(0) saturate(100%) invert(45%) sepia(21%) saturate(1445%) hue-rotate(238deg) brightness(90%) contrast(96%)"}},
    "all-dashboard":{"img":"assets/menuicons/dashboardview.svg","filter":{"filter": "brightness(0) saturate(100%) invert(45%) sepia(21%) saturate(1445%) hue-rotate(238deg) brightness(90%) contrast(96%)"}},
  }

  ngOnInit(): void {
    
    
    // console.log(CssFilterConverter.hexToFilter()
    // Object.keys(this.applist).forEach(key => {
    //   this.applist[key].forEach((element,index) => {
        
    //   this.applist[key][index].menucolor.filterColor.filter=CssFilterConverter.hexToFilter('#13abec').color
    //   });
    // });
//console.log("applist====================>",this.applist)
    // this.applist.forEach((val)=>{
    //   // console.log(val)
    //   val.forEach((elem)=>{
    //     console.log(elem.label,elem.content)
    //   })
    //  })
    // this.applist["Dashboard"] = this.applist["search"]
    // this.applist = {
    //    "search": this.applist["search"],
    //    "manage": this.applist["manage"],
    //    "operate": this.applist["operate"],
    //    "dashboardview":this.applist["manage"]

    // }

        
    // this.categoryColums= Object.keys(this.applist)
    // this.categoryColums = Object.keys(this.applist).filter(
    //   category => this.applist[category].some((item: any) =>
    //     item.is_nonselected_menu_visible === true || item.isSelectable === true
    //   )
    // );


    this.columnsCount= this.categoryColums.length
    if (this.sharedService.forcePwd) {
      let newPwd = this.matdialog.open(NewPwdComponent, { width: "50%", height: "30vh", autoFocus: false });
      newPwd.afterClosed().subscribe((data) => {
        if (data) {
        }
      })
    }
    this.rcrumpService.homeIcon.isSelected = true
    this.rcrumpService.route_crumps[0] = {
      disp_str: "Home",
      routeTo: "home",
      callback: null,
      isParent: false
    }
    this.rcrumpService.route_crumps.length = 1;
    this.rcrumpService.resetMenuList()

  }

  chip_click(module: any) {
//console.log(module,"module")
    if (module.isSelectable && module.url) {
//console.log(module.url)
      this.rcrumpService.homeIcon.isSelected = false
      this.rcrumpService.resetMenuList()
      module["isSelected"] = true
      this.sharedService.$selectedDashboardLabel.next(module)

      // this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
      // console.log("this.router.navigateByUrl(module.url)", module.url)

      this.router.navigateByUrl(module.url)
      
    }
  }
  logSearchClick(){
    this.router.navigateByUrl('dashboard')
  }

  //unsort the key value from the array of objects
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }
  getFilterColor(filterColor:string){
    // console.log("filterColor===============",filterColor,{
    //   "filter":filterColor
    // })
    return {
      "filter":filterColor.replace('"','')
    }
  }
}
